import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Lock } from 'iconoir-react';
import { Card as CardType } from '../services/api';
import { ConfirmModal } from './ConfirmModal';

interface CardOverageLockedModalProps {
  isOpen: boolean;
  onClose: () => void;
  card?: CardType | null;
  userRole?: string;
  onDelete?: (cardId: number) => void;
}

export const CardOverageLockedModal: React.FC<CardOverageLockedModalProps> = ({
  isOpen,
  onClose,
  card,
  userRole,
  onDelete,
}) => {
  const navigate = useNavigate();
  const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);

  if (!isOpen) {
    return null;
  }

  const handleManageOverages = () => {
    onClose();
    navigate('/account', { state: { activeTab: 'overages' } });
  };

  const handleDelete = () => {
    if (!card || !onDelete) return;
    setShowDeleteConfirm(true);
  };

  const handleConfirmDelete = () => {
    if (!card || !onDelete) return;
    setShowDeleteConfirm(false);
    onDelete(card.id);
    onClose();
  };

  // Admin uniquement (cf. hasPermission($board, 'delete')) : seul moyen de
  // repasser sous la limite sans payer.
  const canDelete = userRole === 'admin' && !!card && !!onDelete;

  const message = card?.lock_reason === 'plan_limit_exceeded'
    ? "Cette carte dépasse la limite de votre offre actuelle. Passez à une offre Premium pour y accéder, ou supprimez-la pour repasser sous votre limite."
    : 'Cette carte dépasse la limite de 1000 cartes incluse dans votre offre Premium. Réglez un dépassement pour y accéder.';

  return (
    <>
    <div className="modal-overlay">
      <div className="modal">
        <h2>
          <Lock width={18} height={18} strokeWidth={2} style={{ verticalAlign: 'middle', marginRight: 8 }} />
          Carte verrouillée
        </h2>

        <p>{message}</p>

        <div className="modal-actions">
          <button className="btn btn-primary" onClick={handleManageOverages}>
            Gérer mes dépassements
          </button>

          {canDelete && (
            <button className="btn-danger" onClick={handleDelete} title="Supprimer la carte">
              Supprimer la carte
            </button>
          )}

          <button className="btn btn-secondary" onClick={onClose}>
            Fermer
          </button>
        </div>
      </div>
    </div>

    <ConfirmModal
      isOpen={showDeleteConfirm}
      title="Supprimer la carte"
      message="Voulez-vous vraiment supprimer cette carte ?"
      confirmText="Supprimer"
      onConfirm={handleConfirmDelete}
      onCancel={() => setShowDeleteConfirm(false)}
      variant="danger"
    />
    </>
  );
};
